import React from "react";
import styled from "styled-components";

export const rankColors: { [key: number]: string } = {
    [1]: "#F8AA04",
    [2]: "#F76503",
    [3]: "#CD2500",
    [4]: "#333333",
};

export const MultiRankWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 44px;
    height: 44px;
`;

const StyledRank = styled.div<{rank: Rank, withoutBg?: boolean}>`
    display: flex;
    align-items: flex-start;
    justify-content: center; 
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: ${({rank, withoutBg}) => withoutBg ? "none" : rankColors[rank]};
    font-size: 14px;
    color: ${({rank, withoutBg}) => !withoutBg && ((rank === 4) || (rank === 3)) ? "#FFFFFF" : "#333333"};
`;

export type Rank = 1 | 2 | 3 | 4;

export default ({rank, withoutBg} : {rank: Rank, withoutBg?: boolean}) => <StyledRank
    withoutBg={withoutBg}
    rank={rank}
>{rank}</StyledRank>;
